/* eslint-disable angular/file-name,angular/module-name */
angular.module('zc.zenclerkS', [
  'ngResource',
  'ui.bootstrap',
  'zc.commonApi',
  'zc.core',
]);



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/index.js